export default "__VITE_PUBLIC_ASSET__ac823cc8__"